module.exports = __webpack_public_path__ + "static/media/smLog.1d2ee9a1.png";